// store/college/student-management/store/_saga.js
import { call, put, takeEvery, delay,select, debounce, take } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import CollegeStudentHelper from '../../../../utils/API/BackendHelper/college/student';
import { buildReportFilename } from '../../../../utils/Export/exportUtils';

// Helper function to clean and transform student data
function transformStudentData(students) {
  return students.map(student => {
    const studentData = student.students[0] || {};
    
    return {
      // users table fields
      user_id: student.id,
      username: student.username,
      firstName: student.first_name,
      lastName: student.last_name,
      phone: student.phone,           // users.phone
      is_active: student.is_active,
      college: student.college_id,
      createdAt: student.created_at,
      updatedAt: student.updated_at,

      // students table fields
      id: studentData.id,             // students.id — used in the PUT URL
      name: studentData.candidate_name,
      registration_no: studentData.registration_no,
      degree: studentData.degree,
      gender: studentData.gender,
      dob: studentData.dob,
      current_semester: studentData.current_semester,
      batch: studentData.batch,
      mobile: studentData.mobile,     // students.mobile — separate from users.phone
      subject: studentData.subject,
      category: studentData.category,
      father_name: studentData.father_name,
      mother_name: studentData.mother_name,

      progress: Math.floor(Math.random() * 100),
    };
  });
}

/**
 * Fetch students for the college
 */
function* fetchStudentsSaga(action) {
  try {

    console.log(action);
    const state = yield select();
     const { pagination, filters } = state.collegeStudent;
     const exporting = action.export||false;

 const params = {
      page: pagination.page,
      limit: pagination.limit,
      sortBy: filters.sortBy,
      sortOrder: filters.sortOrder,
      ...action.payload // Override with any specific params
    };

     // Add search parameter only if not empty
    if (filters.search && filters.search.trim()) {
      params.search = filters.search.trim();
    }
    
      // Add status filter only if not 'all'
    if (filters.status && filters.status !== 'all') {
      params.status = filters.status;
    }
if(exporting){
params.page=null;
params.limit=null;

}
    const response = yield call(CollegeStudentHelper.getAllStudents, params);
    
    if (response && response.success) {
    
      const students = response.data || [];
      const transformedStudents = transformStudentData(students);
      console.log('Transformed Students:', transformedStudents);

      if(exporting){
          yield put(actions.fetchAllStudentsWithCurrentFiltersSuccess({
        studentsForExport: transformedStudents,          }
          ));

      }else{
  yield put(actions.fetchStudentsSuccess({
        students: transformedStudents,
        pagination: response.pagination
      }));
      }
    
    } else if (exporting) {
      yield put(actions.fetchAllStudentsWithCurrentFiltersFailure(response?.message || 'Failed to export students'));
    } else {
      yield put(actions.fetchStudentsFailure(response?.message || 'Failed to fetch students'));
    }
  } catch (error) {
    console.error('Error in fetchStudentsSaga:', error);
    // Use the export failure action when exporting so exportLoading is cleared too
    if (action.export) {
      yield put(actions.fetchAllStudentsWithCurrentFiltersFailure(error.message || 'Failed to export students'));
    } else {
      yield put(actions.fetchStudentsFailure(error.message || 'Failed to fetch students'));
    }
  }
}



// Watch for pagination and filter changes to refetch data
function* handlePaginationChange(action) {
  yield delay(100); // Small delay to allow state to update
  console.log("collegeId in handlePaginationChange:", action.payload);
  yield put(actions.fetchStudentsRequest({ collegeId: action.payload.collegeId }));
}

function* handleSearchChange(action) {
  yield delay(500); // Debounce search
  yield put(actions.fetchStudentsRequest({ collegeId: action.payload.collegeId }));
}

function* handleFilterChange(action) {
  yield delay(100); // Small delay to allow state to update
  yield put(actions.fetchStudentsRequest({ collegeId: action.payload.collegeId }));
}








/**
 * Upload students via Excel file
 */
export const uploadStudentsSaga = function* (action) {
  try {
    console.log('Starting uploadStudentsSaga with payload:', action.payload);
    const { files,  semester, batch } = action.payload;
    console.log(semester,batch);
    
    if (!files || files.length === 0) {
      yield put(actions.uploadStudentsFailure('No file selected'));
      return;
    }

    const file = files[0];
    
    // ✅ Parse Excel file on frontend
    const XLSX = require('xlsx'); // Install: npm install xlsx
    
    try {
      // Read file as array buffer
      const arrayBuffer = yield new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });

      // Parse Excel file
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      
      // Convert to JSON
      const studentsData = XLSX.utils.sheet_to_json(worksheet);
      
      console.log('📊 Parsed Excel data:', studentsData.length, 'students');
      console.log('📋 First student:', studentsData[0]);
      
      if (studentsData.length === 0) {
        yield put(actions.uploadStudentsFailure('Excel file is empty'));
        return;
      }

      // ✅ Transform data to match backend expectations
      const transformedStudents = studentsData.map((student, index) => {
        try {
          return {
            // ✅ User creation fields (required by backend)
            username: student.email || `student${index + 1}@temp.com`,
            email: student.email || `student${index + 1}@temp.com`,
            password: student.password || 'TempPass@123', // Backend will generate if not provided
            role: 'student',
            first_name: student.first_name || '', // ✅ Added required field
            last_name: student.last_name || '',   // ✅ Added required field
            phone: student.phone, // ✅ Added required field
            college_id: '', // ✅ Backend will handle this from auth context
            is_active: true,  // ✅ Added required field
            is_credentials_sent: false, // ✅ Added required field
            // ✅ Student profile fields matching database schema
            candidate_name: student.candidate_name || '',
            registration_no: student.registration_no || null,
            nad_number: student.nad_number || null,
            gender: student.gender || null,
            dob: student.dob || null,
            age_years: student.age_years ? parseInt(student.age_years) : null,
            father_name: student.father_name || null,
            mother_name: student.mother_name || null,
            mobile: student.mobile || null,
            alt_phone: student.alt_phone || null,
            aadhaar_number: student.aadhaar_number || null,
            aadhaar_enrollment: student.aadhaar_enrollment || null,
            corresponding_address: student.corresponding_address || null,
            degree: student.degree || null,
            subject: student.subject || null,
            subject_1: student.subject_1 || null,
            subject_2: student.subject_2 || null,
            subject_3: student.subject_3 || null,
            minor: student.minor || null,
            category: student.category || null,
            reservation: student.reservation || null,
            other: student.other || null,
            ews: student.ews === true || student.ews === 'true' || student.ews === 1,
            xth_marks_sheet_serial: student.xth_marks_sheet_serial || null,
            xth_pass_year: student.xth_pass_year ? parseInt(student.xth_pass_year) : null,
            xii_board: student.xii_board || null,
            xii_roll_no: student.xii_roll_no || null,
            admission_date: student.admission_date || new Date().toISOString().split('T')[0],
            admitted_as: student.admitted_as || null,
            admission_type: student.admission_type || null,
            list_number: student.list_number ? parseInt(student.list_number) : null,
            // ✅ Handle array fields from comma-separated strings
            skill: student.skill ? student.skill.toString().split(',').map(s => s.trim()) : [],
            cocurricular: student.cocurricular ? student.cocurricular.toString().split(',').map(s => s.trim()) : [],
          
          
          };
        } catch (transformError) {
          console.error(`Error transforming student at row ${index + 2}:`, transformError);
          throw new Error(`Row ${index + 2}: Invalid data format`);
        }
      });

      console.log('✅ Transformed students data:', transformedStudents.length);
      console.log('📋 Sample transformed student:', JSON.stringify(transformedStudents[0], null, 2));

      // ✅ Send JSON data to backend (not FormData)
      const requestData = {
        users: transformedStudents,
        role: 'student',
        batch: batch || null,
        semester: semester || null,
      };

      const response = yield call(CollegeStudentHelper.bulkEnrollStudents, requestData);
      
      if (response && response.success) {
        const result = {
          total: transformedStudents.length,
          successful: response.data.successful?.length || 0,
          failed: response.data.failed?.length || 0,
          successData: response.data.successful || [],
          errors: response.data.failed?.map((failure, index) => 
            `${failure.username}: ${failure.error}`
          ) || []
        };
        
        console.log('✅ Upload result:', result);
        yield put(actions.uploadStudentsSuccess(result));
        
        // Refresh the students list after successful upload
        yield delay(1000);
        yield put(actions.fetchStudentsRequest());
      } else {
        console.error('❌ Backend response failed:', response);
        yield put(actions.uploadStudentsFailure(response?.message || 'Upload failed'));
      }

    } catch (parseError) {
      console.error('❌ Error parsing Excel file:', parseError);
      yield put(actions.uploadStudentsFailure('Invalid Excel file format'));
    }

  } catch (error) {
    console.error('💥 Error in uploadStudentsSaga:', error);
    yield put(actions.uploadStudentsFailure(error.message || 'Upload failed. Please try again.'));
  }
};

/**
 * Download student upload template
 */
function* downloadTemplateSaga() {
  try {
    const blob = yield call(CollegeStudentHelper.downloadTemplate);
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'student_upload_template.xlsx';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
    yield put(actions.downloadTemplateSuccess());
  } catch (error) {
    console.error('Error in downloadTemplateSaga:', error);
    yield put(actions.downloadTemplateFailure(error.message || 'Failed to download template'));
  }
}

/**
 * Toggle student status (activate/deactivate)
 */
function* toggleStudentStatusSaga(action) {
  try {
    const { studentId, isActive } = action.payload;
    
    const response = yield call(CollegeStudentHelper.toggleStudentStatus, studentId, isActive);
    
    if (response && response.success) {
      yield put(actions.toggleStudentStatusSuccess({ studentId, isActive }));
      
      // Refresh students list
      yield put(actions.fetchStudentsRequest({ collegeId: action.payload.collegeId }));
    } else {
      yield put(actions.toggleStudentStatusFailure(response?.message || 'Failed to update student status'));
    }
  } catch (error) {
    console.error('Error in toggleStudentStatusSaga:', error);
    yield put(actions.toggleStudentStatusFailure(error.message || 'Failed to update student status'));
  }
}

/**
 * Create single student
 */
function* createStudentSaga(action) {
  try {
    const studentData = action.payload;
    
    const response = yield call(CollegeStudentHelper.createStudent, studentData);
    
    if (response && response.success) {
      const newStudent = {
        id: response.data.user.id,
        name: `${response.data.user.first_name} ${response.data.user.last_name}`,
        email: response.data.user.email,
        rollNumber: studentData.studentId,
        firstName: response.data.user.first_name,
        lastName: response.data.user.last_name,
        phone: response.data.user.phone,
        status: response.data.user.is_active ? 'active' : 'suspended',
        progress: 0,
        createdAt: response.data.user.created_at,
        defaultPassword: response.data.defaultPassword
      };
      
      yield put(actions.createStudentSuccess(newStudent));
      
      // Refresh students list
      yield put(actions.fetchStudentsRequest());
    } else {
      yield put(actions.createStudentFailure(response?.message || 'Failed to create student'));
    }
  } catch (error) {
    console.error('Error in createStudentSaga:', error);
    yield put(actions.createStudentFailure(error.message || 'Failed to create student'));
  }
}

/**
 * Get students progress
 */
function* fetchStudentsProgressSaga(action) {
  try {
    const params = action.payload || {};
    
    const response = yield call(CollegeStudentHelper.getStudentsProgress, params);
    
    if (response && response.success) {
      yield put(actions.fetchStudentsProgressSuccess(response.data));
    } else {
      yield put(actions.fetchStudentsProgressFailure(response?.message || 'Failed to fetch progress'));
    }
  } catch (error) {
    console.error('Error in fetchStudentsProgressSaga:', error);
    yield put(actions.fetchStudentsProgressFailure(error.message || 'Failed to fetch students progress'));
  }
}

/**
 * Retry sending credentials SMS
 */
function* retryCredentialsSMSSaga(action) {
  try {
    const { studentIds } = action.payload;
    
    const response = yield call(CollegeStudentHelper.retryCredentialsSMS, studentIds);
    
    if (response && response.success) {
      yield put(actions.retryCredentialsSMSSuccess(response.data));
    } else {
      yield put(actions.retryCredentialsSMSFailure(response?.message || 'Failed to retry SMS'));
    }
  } catch (error) {
    console.error('Error in retryCredentialsSMSSaga:', error);
    yield put(actions.retryCredentialsSMSFailure(error.message || 'Failed to retry SMS'));
  }
}

/**
 * Bulk enroll students
 */
function* bulkEnrollSaga(action) {
  try {
    const { studentIds, courseId } = action.payload;
    
    const response = yield call(CollegeStudentHelper.bulkEnrollStudents, studentIds, courseId);
    
    if (response && response.success) {
      const result = {
        enrolled: studentIds.length,
        course: courseId,
        details: response.data
      };
      
      yield put(actions.bulkEnrollSuccess(result));
      
      // Refresh students list to show updated enrollment status
      yield put(actions.fetchStudentsRequest());
    } else {
      yield put(actions.bulkEnrollFailure(response?.message || 'Bulk enrollment failed'));
    }
  } catch (error) {
    console.error('Error in bulkEnrollSaga:', error);
    yield put(actions.bulkEnrollFailure(error.message || 'Bulk enrollment failed'));
  }
}

/**
 * Search students
 */
function* searchStudentsSaga(action) {
  try {
    const { searchTerm, filters } = action.payload;
    
    const response = yield call(CollegeStudentHelper.searchStudents, searchTerm, filters);
    
    if (response && response.success) {
      const students = response.data || [];
      const transformedStudents = transformStudentData(students);
      
      yield put(actions.searchStudentsSuccess(transformedStudents));
    } else {
      yield put(actions.searchStudentsFailure(response?.message || 'Search failed'));
    }
  } catch (error) {
    console.error('Error in searchStudentsSaga:', error);
    yield put(actions.searchStudentsFailure(error.message || 'Search failed'));
  }
}

/**
 * Get student by ID
 */
function* getStudentByIdSaga(action) {
  try {
    const { studentId } = action.payload;
    
    const response = yield call(CollegeStudentHelper.getStudentById, studentId);
    
    if (response && response.success) {
      const transformedStudent = transformStudentData([response.data])[0];
      yield put(actions.getStudentByIdSuccess(transformedStudent));
    } else {
      yield put(actions.getStudentByIdFailure(response?.message || 'Failed to fetch student'));
    }
  } catch (error) {
    console.error('Error in getStudentByIdSaga:', error);
    yield put(actions.getStudentByIdFailure(error.message || 'Failed to fetch student'));
  }
}

/**
 * Update student
 */
function* updateStudentSaga(action) {
  try {
    const { studentId, updateData } = action.payload;
    
    const response = yield call(CollegeStudentHelper.updateStudent, studentId, updateData);
    
    if (response && response.success) {
      const transformedStudent = transformStudentData([response.data])[0];
      yield put(actions.updateStudentSuccess(transformedStudent));
      
      // Refresh students list with current state
      const state = yield select();
      const { pagination, filters } = state.collegeStudent;
      
      yield put(actions.fetchStudentsRequest({
        page: pagination.page,
        limit: pagination.limit,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        search: filters.search,
        status: filters.status !== 'all' ? filters.status : undefined,
        degree: filters.degree !== 'all' ? filters.degree : undefined,
        batch: filters.batch || undefined,
      }));
    } else {
      yield put(actions.updateStudentFailure(response?.message || 'Failed to update student'));
    }
  } catch (error) {
    console.error('Error in updateStudentSaga:', error);
    yield put(actions.updateStudentFailure(error.message || 'Failed to update student'));
  }
}

/**
 * Delete student
 */
function* deleteStudentSaga(action) {
  try {
    const { studentId } = action.payload;
    
    const response = yield call(CollegeStudentHelper.deleteStudent, studentId);
    
    if (response && response.success) {
      yield put(actions.deleteStudentSuccess(studentId));
      
      // Refresh students list
      yield put(actions.fetchStudentsRequest());
    } else {
      yield put(actions.deleteStudentFailure(response?.message || 'Failed to delete student'));
    }
  } catch (error) {
    console.error('Error in deleteStudentSaga:', error);
    yield put(actions.deleteStudentFailure(error.message || 'Failed to delete student'));
  }
}

/**
 * Get students by course
 */
function* getStudentsByCourseSaga(action) {
  try {
    const { courseId, params } = action.payload;
    
    const response = yield call(CollegeStudentHelper.getStudentsByCourse, courseId, params);
    
    if (response && response.success) {
      const students = response.data || [];
      const transformedStudents = transformStudentData(students);
      
      yield put(actions.getStudentsByCourseSuccess({
        courseId,
        students: transformedStudents
      }));
    } else {
      yield put(actions.getStudentsByCourseFailure(response?.message || 'Failed to fetch students by course'));
    }
  } catch (error) {
    console.error('Error in getStudentsByCourseSaga:', error);
    yield put(actions.getStudentsByCourseFailure(error.message || 'Failed to fetch students by course'));
  }
}

/**
 * Export students
 */
function* exportStudentsSaga(action) {
  try {
    const exportParams = action.payload || {};
    
    const blob = yield call(CollegeStudentHelper.exportStudents, exportParams);
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = buildReportFilename('students_export', exportParams, 'xlsx');
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
    yield put(actions.exportStudentsSuccess());
  } catch (error) {
    console.error('Error in exportStudentsSaga:', error);
    yield put(actions.exportStudentsFailure(error.message || 'Failed to export students'));
  }
}
function* fetchDegreesSaga(action) {
  try {
    const { collegeId } = action.payload;
    console.log('Fetching degrees for college ID in saga:', collegeId);
    // Call your backend API to fetch degrees
    const response = yield call(CollegeStudentHelper.fetchDegreesByCollege, collegeId);
    yield put(actions.fetchDegreesSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchDegreesFailure(error.message));
  }
}

function* setDegreeFilterSaga(action) {
  try {
    const { degree, collegeId } = action.payload;
    
    // Get current state to include all filters
    const state = yield select();
    const { filters, pagination } = state.collegeStudent;
    
    // Fetch students with all filters including the new degree filter
    yield put(actions.fetchStudentsRequest({
      collegeId: collegeId || undefined,
      degree: degree !== 'all' ? degree : undefined,
      batch: filters.batch || undefined,
      search: filters.search || undefined,
      status: filters.status !== 'all' ? filters.status : undefined,
      page: 1, // Reset to first page when filter changes
      limit: pagination.limit
    }));
  } catch (error) {
    console.error('Error in setDegreeFilterSaga:', error);
  }
}


function * fetchStudentsForExportSaga(action) {
  try {
   
    const {  collegeId } = action.payload;
    // Get current state to include all filters
    const state = yield select();
    const { filters} = state.collegeStudent;
    
    // Fetch students with all filters including the new batch filter
    yield put(actions.fetchStudentsRequest({
      collegeId: collegeId || undefined,
      degree: filters.degree !== 'all' ? filters.degree : undefined,
      batch: filters.batch || undefined,
      search: filters.search || undefined,
      status: filters.status !== 'all' ? filters.status : undefined,
      
    },true));
  } catch (error) {
    console.error('Error in setBatchFilterSaga:', error);
  }
}


function* setBatchFilterSaga(action) {
  try {
    const { batch, collegeId } = action.payload;
    
    // Get current state to include all filters
    const state = yield select();
    const { filters, pagination } = state.collegeStudent;
    
    // Fetch students with all filters including the new batch filter
    yield put(actions.fetchStudentsRequest({
      collegeId: collegeId || undefined,
      degree: filters.degree !== 'all' ? filters.degree : undefined,
      batch: batch || undefined,
      search: filters.search || undefined,
      status: filters.status !== 'all' ? filters.status : undefined,
      page: 1, // Reset to first page when filter changes
      limit: pagination.limit
    }));
  } catch (error) {
    console.error('Error in setBatchFilterSaga:', error);
  }
}

function* setSemesterFilterSaga(action) {
  try {
    const { semester, collegeId } = action.payload;

    // Get current state to include all filters
    const state = yield select();
    const { filters, pagination } = state.collegeStudent;

    // Fetch students with all filters including semester
    yield put(actions.fetchStudentsRequest({
      collegeId: collegeId || undefined,
      degree: filters.degree !== 'all' ? filters.degree : undefined,
      batch: filters.batch || undefined,
      semester: semester !== 'all' ? semester : undefined,
      search: filters.search || undefined,
      status: filters.status !== 'all' ? filters.status : undefined,
      page: 1,
      limit: pagination.limit
    }));
  } catch (error) {
    console.error('Error in setSemesterFilterSaga:', error);
  }
}

/**
 * Get dashboard statistics
 */
function* getDashboardStatsSaga() {
  try {
    const response = yield call(CollegeStudentHelper.getDashboardStats);
    
    if (response && response.success) {
      yield put(actions.getDashboardStatsSuccess(response.data));
    } else {
      yield put(actions.getDashboardStatsFailure(response?.message || 'Failed to fetch dashboard stats'));
    }
  } catch (error) {
    console.error('Error in getDashboardStatsSaga:', error);
    yield put(actions.getDashboardStatsFailure(error.message || 'Failed to fetch dashboard stats'));
  }
}

/**
 * Root saga for college student management
 */
function* collegeStudentSaga() {
  yield takeEvery(types.FETCH_STUDENTS_REQUEST, fetchStudentsSaga);
   yield takeEvery(types.SET_PAGE, handlePaginationChange);
  yield takeEvery(types.SET_PAGE_SIZE, handlePaginationChange);
    yield takeEvery(types.SET_SEARCH, handleSearchChange);
  yield takeEvery(types.SET_STATUS_FILTER, handleFilterChange);
  yield takeEvery(types.SET_SORT, handleFilterChange);
  yield takeEvery(types.UPLOAD_STUDENTS_REQUEST, uploadStudentsSaga);
  yield takeEvery(types.DOWNLOAD_TEMPLATE_REQUEST, downloadTemplateSaga);
  yield takeEvery(types.TOGGLE_STUDENT_STATUS_REQUEST, toggleStudentStatusSaga);
  yield takeEvery(types.CREATE_STUDENT_REQUEST, createStudentSaga);
  yield takeEvery(types.FETCH_STUDENTS_PROGRESS_REQUEST, fetchStudentsProgressSaga);
  yield takeEvery(types.RETRY_CREDENTIALS_SMS_REQUEST, retryCredentialsSMSSaga);
  yield takeEvery(types.BULK_ENROLL_REQUEST, bulkEnrollSaga);
  yield takeEvery(types.SEARCH_STUDENTS_REQUEST, searchStudentsSaga);
  yield takeEvery(types.GET_STUDENT_BY_ID_REQUEST, getStudentByIdSaga);
  yield takeEvery(types.UPDATE_STUDENT_REQUEST, updateStudentSaga);
  yield takeEvery(types.DELETE_STUDENT_REQUEST, deleteStudentSaga);
  yield takeEvery(types.GET_STUDENTS_BY_COURSE_REQUEST, getStudentsByCourseSaga);
  yield takeEvery(types.EXPORT_STUDENTS_REQUEST, exportStudentsSaga);
  yield takeEvery(types.GET_DASHBOARD_STATS_REQUEST, getDashboardStatsSaga);
    yield takeEvery(types.FETCH_DEGREES_REQUEST, fetchDegreesSaga);
  yield takeEvery(types.SET_DEGREE_FILTER, setDegreeFilterSaga);
  yield debounce(500,types.SET_BATCH_FILTER, setBatchFilterSaga);
  yield takeEvery(types.SET_SEMESTER_FILTER, setSemesterFilterSaga);
  yield takeEvery(types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_REQUEST, fetchStudentsForExportSaga);
  // Legacy support for blacklist (now using toggle status)
  yield takeEvery(types.BLACKLIST_STUDENT_REQUEST, function* (action) {
    yield put(actions.toggleStudentStatusRequest({
      studentId: action.payload,
      isActive: false
    }));
  });
}

export default collegeStudentSaga;
